import { render, staticRenderFns } from "./novin.vue?vue&type=template&id=53c4d4f4"
import script from "./novin.vue?vue&type=script&lang=js"
export * from "./novin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports